import React from 'react';
import { SEO } from '../components/SEO';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { breadcrumbSchema } from '../utils/structuredData';
import { ArrowLeftIcon } from 'lucide-react';
export function ImpressumPage() {
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Impressum',
    url: 'https://close-crm-agentur.de/impressum'
  }];
  const structuredData = [breadcrumbSchema(breadcrumbs)];
  return <>
      <SEO title="Impressum" description="Impressum der Close CRM Agentur - Rechtliche Informationen und Kontaktdaten." canonical="https://close-crm-agentur.de/impressum" noindex={true} structuredData={structuredData} data-id="element-476" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-477">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-478">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-479">
            <div className="flex items-center justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-480">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0 sm:flex-1" aria-label="Close CRM Agentur Homepage" data-id="element-481">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-482">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-483">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-484">
                  Close CRM Agentur
                </span>
              </a>

              {/* Language Switcher - Always visible */}
              <LanguageSwitcher className="absolute right-3 sm:relative sm:right-0" data-id="element-485" />

              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-486">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-487" />
                Zurück zur Startseite
              </a>
            </div>
          </nav>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-16" data-id="element-488">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-489">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-490">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-491">Impressum</h1>

              <div className="space-y-8 text-gray-300" data-id="element-492">
                <section data-id="element-493">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-494">
                    Adresse
                  </h2>
                  <p className="leading-relaxed" data-id="element-495">
                    CRM Kraft LLC
                    <br data-id="element-496" />
                    Vertreten durch: Justus Kraft
                    <br data-id="element-497" />
                    7901 4th St. N, Ste. 300
                    <br data-id="element-498" />
                    St. Petersburg, FL 33702
                    <br data-id="element-499" />
                    United States of America
                  </p>
                </section>

                <section data-id="element-500">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-501">
                    Kontakt
                  </h2>
                  <p className="leading-relaxed" data-id="element-502">
                    Telefon:{' '}
                    <a href="tel:+4915735999071" className="text-[#0ea5e9] hover:underline" data-id="element-503">
                      +49 157 35999071
                    </a>
                    <br data-id="element-504" />
                    E-Mail:{' '}
                    <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-505">
                      justus@crm-kraft.de
                    </a>
                  </p>
                </section>

                <section data-id="element-506">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-507">
                    EU-Streitschlichtung
                  </h2>
                  <p className="leading-relaxed" data-id="element-508">
                    Die Europäische Kommission stellt eine Plattform zur
                    Online-Streitbeilegung (OS) bereit:{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-509">
                      https://ec.europa.eu/consumers/odr/
                    </a>
                    . Unsere E-Mail-Adresse finden Sie oben im Impressum.
                  </p>
                </section>

                <section data-id="element-510">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-511">
                    Verbraucherstreitbeilegung/Universalschlichtungsstelle
                  </h2>
                  <p className="leading-relaxed" data-id="element-512">
                    Wir sind nicht bereit oder verpflichtet, an
                    Streitbeilegungsverfahren vor einer
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-513">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-514">
            <p className="text-gray-600 text-sm" data-id="element-515">
              © {new Date().getFullYear()} Close CRM Agentur. Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}